export const SET_COLLECTION = 'SET_COLLECTION';
export const SET_QUERY_TEXT = 'SET_QUERY_TEXT';
export const SET_LOCATION_ID = 'SET_LOCATION_ID';
export const SHOW_MORE_SEARCH_RESULTS = 'SHOW_MORE_SEARCH_RESULTS';
export const SHOW_GALLERY_MAP = 'SHOW_GALLERY_MAP';
export const HIDE_GALLERY_MAP = 'HIDE_GALLERY_MAP';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
export const SET_MEDIA_FILTER = 'SET_MEDIA_FILTER';
export const INCREMENT_SEARCH_KEY = 'INCREMENT_SEARCH_KEY';
